import { RESET_REASIGN_FORM } from '../actionTypes';
import { contactActions } from '../reducer';

export default () => contactActions[RESET_REASIGN_FORM]();
